import api from './api';
import type { 
  User, 
  LoginCredentials, 
  RegisterData, 
  AuthResponse, 
  ChangePasswordData 
} from '../types/auth';

export const authService = {
  // ユーザー登録
  async register(data: RegisterData): Promise<AuthResponse> {
    const response = await api.post<AuthResponse>('/auth/register', data);
    return response.data;
  },

  // ログイン
  async login(credentials: LoginCredentials): Promise<AuthResponse> {
    const response = await api.post<AuthResponse>('/auth/login', credentials);
    return response.data;
  },

  // 現在のユーザー情報取得
  async getCurrentUser(): Promise<User> {
    const response = await api.get<User>('/auth/me');
    return response.data;
  },

  // パスワード変更
  async changePassword(data: ChangePasswordData): Promise<{ message: string }> {
    const response = await api.put<{ message: string }>('/auth/change-password', data);
    return response.data;
  },

  // ログアウト
  async logout(): Promise<{ message: string }> {
    const response = await api.post<{ message: string }>('/auth/logout');
    return response.data;
  },

  // トークンとユーザー情報をローカルストレージに保存
  saveAuthData(token: string, user: User): void {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
  },

  // ローカルストレージからトークンとユーザー情報を取得
  getAuthData(): { token: string | null; user: User | null } {
    const token = localStorage.getItem('token');
    const userStr = localStorage.getItem('user');
    const user = userStr ? JSON.parse(userStr) : null;
    return { token, user };
  },

  // 認証データをクリア
  clearAuthData(): void {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },

  // 認証状態チェック
  isAuthenticated(): boolean {
    const { token } = this.getAuthData();
    return !!token;
  },
};